import _ from "lodash";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import { fetchGetClient } from "../queries/clients";

export const useClient = (site: string | undefined) => {
  const dispatch = useDispatch();
  const clientQuery = useQuery(["clients", site], fetchGetClient(dispatch), {
    enabled: !!site,
  });
  const clientId = useMemo(() => _.get(clientQuery?.data, "payload.data.id"), [clientQuery?.data]);
  return {
    query: clientQuery,
    cityId: clientId,
    clientId,
  };
};
